import React from "react";
import styles from "./commentSection.module.css";
import { CommentItem } from "./components/commentItem/commentItem.index";
import { Timeline } from "./components/timeline/timeline.index";
import { IEscalationComments } from "../../../../../../Models/applicationModels";
import { COMMENT_ITEM_TITLE_MAP } from "./commentSection.utils";

export const CommentSection = ({ commentItems, handleCancelComment, opportunityUid, setCommentItems, initialStatus }: { commentItems: IEscalationComments[], handleCancelComment: (index: number) => void, opportunityUid: string, setCommentItems: (items: IEscalationComments[]) => void, initialStatus: string | null }) => {
    return (
        <div className={styles.commentSectionWrapper}>
            <div className={styles.commentSection}>
                {commentItems.map((item, index) => {
                    const { commentType, escalationStatus, comment, files, createdBy, createdOn, applicationEscalationUid, isCommentEmailSend } = item;
                    return (
                        <div key={item.commentUid} className={styles.commentRow}>
                            <div className={styles.timelineColumn}>
                                <Timeline
                                    type={item.commentType}
                                />
                            </div>
                        <div className={styles.commentColumn}>
                            <CommentItem
                                type={commentType}
                                status={escalationStatus}
                                title={COMMENT_ITEM_TITLE_MAP[commentType]}
                                content={comment}
                                files={files}
                                createdBy={createdBy}
                                createdAt={createdOn}
                                onCancel={() => handleCancelComment(index)}
                                opportunityUid={opportunityUid}
                                applicationEscalationUid={applicationEscalationUid}
                                setCommentItems={setCommentItems}       
                                initialStatus={initialStatus}
                                isCommentEmailSend={isCommentEmailSend}
                            />
                        </div>
                        </div>
                    )})
                }
            </div>
        </div>
    );
};
